/**
 * Shared utility for reCAPTCHA configuration
 * Centralizes environment variable checks to ensure consistency
 */

export interface RecaptchaConfig {
  enabled: boolean;
  siteKey: string;
}

/**
 * Get reCAPTCHA configuration from environment variables
 * @returns Configuration object with enabled state and site key
 */
export const getRecaptchaConfig = (): RecaptchaConfig => {
  const REACT_APP_RECAPTCHA_ON = import.meta.env.REACT_APP_RECAPTCHA_ON !== "false";
  const ANTI_BOT_PROVIDER_ID = import.meta.env.ANTI_BOT_PROVIDER_ID ?? "";
  
  const config = {
    enabled: REACT_APP_RECAPTCHA_ON && !!ANTI_BOT_PROVIDER_ID,
    siteKey: ANTI_BOT_PROVIDER_ID
  };
  
  console.log('[recaptchaConfig] getRecaptchaConfig:', {
    envOn: import.meta.env.REACT_APP_RECAPTCHA_ON,
    envKey: ANTI_BOT_PROVIDER_ID ? `${ANTI_BOT_PROVIDER_ID.substring(0, 10)}...` : 'empty',
    parsedOn: REACT_APP_RECAPTCHA_ON,
    enabled: config.enabled,
    siteKey: config.siteKey ? `${config.siteKey.substring(0, 10)}...` : 'empty'
  });
  
  return config;
};

/**
 * Check if reCAPTCHA is enabled and configured
 * @returns true if reCAPTCHA is enabled and has a valid site key
 */
export const isRecaptchaEnabled = (): boolean => {
  const config = getRecaptchaConfig();
  return config.enabled && !!config.siteKey;
};

